const state= {
    loading: false,
    service_report:{
        items:[],
        total:0,
    },
    groups: []
};

const getters = {
    ServiceReport : (state) => state.service_report,
    Loading : (state) => state.loading,
    groupServiceReports : (state) => state.groups,
};


const actions = {
    async getItems({commit}, params){
        return new Promise (( resolve, reject ) => {
            const url = params.api
            delete params.api
            global.axios.get(`/api/${url}`, {params:params})
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => {
                    reject( error )
                });
        });
    },
    async saveItem({commit}, params){
        let formData = new FormData();
        formData.append('order_id', params.data.order_id || '');
        formData.append('description', params.data.description || '');
        formData.append('work_finding_action_taken_group_id', params.data.work_finding_action_taken_group_id || '');
        if(params.photos.length) {
            for(let i = 0; i < params.photos.length; i++){
                formData.append(`photos[${i}]`, params.photos[i]);
            }
        }

        let api = `/api/${params.api}`;
        delete params.api
        if(params.data.id)
            api += `/${params.data.id}`;

        return new Promise (( resolve, reject ) => {
            global.axios(api, {
                method: 'POST',
                data: formData,
                headers: {
                    Accept: "application/json",
                },
            })
            .then(response => {
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    },
    async deleteItem({commit}, params){
        const url = params.api
        delete params.api
        return new Promise (( resolve, reject ) => {
            global.axios.delete(`/api/${url}`, {
                data: params
            })
            .then(response => {
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    },
    async deleteAttachments({ commit }, params) {
        return new Promise((resolve, reject) => {

            global.axios(`/api/attachments`, {
                    method: "DELETE",
                    data: { ids: params.ids },
                    headers: {
                        Accept: "application/json",
                    },
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },

    // Group Service Report
    async getGroupServiceReport({commit}, params){
        commit( 'setLoading', true );
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/work-finding-action-taken-groups`, { params: params })
                .then(response => {
                    commit( 'setLoading', false );
                    commit( 'setGroupServiceReport', response.data.data.items );
                    resolve( response.data.data );
                })
                .catch(error => {
                    commit( 'setLoading', false );
                    reject( error )
                });
        });
    },
    async createGroupServiceReport({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios(`/api/work-finding-action-taken-groups`, {
                method: 'POST',
                data: params,
                headers: {
                    Accept: "application/json",
                },
            })
            .then(response => {
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    },
    async deleteGroupServiceReport({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.delete(`/api/work-finding-action-taken-groups`, {
                data:params
            })
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
};

const mutations = {
    setLoading (state, data) {
        state.loading = data;
    },
    setGroupServiceReport (state, data) {
        state.groups = data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
